import { render } from "./AddEmployeeModalComponent.vue?vue&type=template&id=23f84554&scoped=true"
import script from "./AddEmployeeModalComponent.vue?vue&type=script&lang=js"
export * from "./AddEmployeeModalComponent.vue?vue&type=script&lang=js"

import "./AddEmployeeModalComponent.vue?vue&type=style&index=0&id=23f84554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f84554"]])

export default __exports__